module.exports = __webpack_public_path__ + "static/media/times-square.d9f1eac3.svg";